import React from 'react';
import Alert from '@mui/material/Alert';

const Info = ({ message }) => <Alert severity='info'>{message}</Alert>;

export default Info;
